import React, { useState } from "react";
import axios from "axios";
import Signup from "./components/Signup";
import Login from "./components/Login";
import Home from "./components/Home";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import "./App.css";
import { Button } from "@mui/material";
import { API_BASE_URL, SessionManager } from "./utils/consts";
import { LoadScript } from "@react-google-maps/api";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom"; // Changed 'Switch' to 'Routes'
import { ThemeProvider, createTheme } from "@mui/material/styles"; // Import ThemeProvider and createTheme

function App() {
  const [email, setEmail] = useState<string>("");
  const [password, setPassword] = useState<string>("");
  const [name, setName] = useState<string>("");
  const [phone_number, setphoneNumber] = useState<string>("");
  const [address, setAddress] = useState<string>("");
  const [company_name, setCompanyName] = useState<string>("");
  const [token, setToken] = useState<string | null>(null);
  const [isSignup, setIsSignup] = useState<boolean>(true); // New state to toggle between forms
  const [signedTermsAndConditions, setSignedTermsAndConditions] =
    useState<boolean>(false);

  const signup = async () => {
    try {
      await axios.post(`${API_BASE_URL}/signup`, {
        email,
        password,
        phone_number: phone_number,
        name,
        company_name,
        address,
        signed_terms_and_conditions: signedTermsAndConditions,
      });
      setIsSignup(false); // Switch back to login after successful signup
    } catch (error) {
      alert("Signup failed!");
    }
  };

  const login = async () => {
    try {
      const response = await axios.post(
        `${API_BASE_URL}/token`,
        new URLSearchParams({
          username: email,
          password,
          grant_type: "password",
        }),
        {
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
          },
        }
      );
      setToken(response.data.access_token);

      // save token to local storage
    } catch (error) {
      alert("Login failed!");
    }
  };

  const signOut = () => {
    setToken(null);
  };

  const getData = async (endpoint: string) => {
    if (!token) {
      signOut();
      return null;
    }

    try {
      const response = await axios.get(`${API_BASE_URL}/${endpoint}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (response.status === 401) {
        signOut();
        return null;
      }

      if (response.status === 200) {
        return response.data;
      } else {
        throw new Error("Failed to fetch data");
      }
    } catch (error) {
      signOut();
      return null;
    }
  };

  const sessionManager: SessionManager = {
    getToken: () => token,
    setToken: (token: string) => setToken(token),
    signOut: signOut,
    getData: getData,
  };

  // Create a custom theme with dark green and sharp corners
  const theme = createTheme({
    palette: {
      primary: {
        main: "#006400", // Dark green color
      },
      secondary: {
        main: "#8B0000", // Optional: Dark red for secondary color
      },
    },
    shape: {
      borderRadius: 2, // Sharp corners
    },
    typography: {
      fontFamily: "Roboto, sans-serif", // Change this to your desired font family
    },
  });

  return (
    <ThemeProvider theme={theme}>
      {" "}
      {/* Wrap your app with ThemeProvider */}
      <Router>
        <div className="App">
          <LoadScript
            googleMapsApiKey={process.env.REACT_APP_GOOGLE_MAPS_API_KEY || ""}
            libraries={["places"]}
          >
            <Routes>
              <Route
                path="/"
                element={
                  !token ? (
                    <React.Fragment>
                      <AppBar position="static">
                        <Toolbar>
                          <div style={{ flexGrow: 1 }}>
                            <img
                              src="/landcalc.png"
                              alt="Lanc Calc"
                              style={{ height: "80px" }}
                            />
                          </div>
                        </Toolbar>
                      </AppBar>

                      <div style={{ marginTop: "20px", textAlign: "center" }}>
                        {isSignup ? (
                          <Signup
                            email={email}
                            password={password}
                            name={name}
                            companyName={company_name}
                            phoneNumber={phone_number}
                            address={address}
                            signedTermsAndConditions={signedTermsAndConditions}
                            setEmail={setEmail}
                            setPassword={setPassword}
                            setName={setName}
                            setPhoneNumber={setphoneNumber}
                            setCompanyName={setCompanyName}
                            setAddress={setAddress}
                            signup={signup}
                            setSignedTermsAndConditions={
                              setSignedTermsAndConditions
                            }
                          />
                        ) : (
                          <Login
                            email={email}
                            password={password}
                            setEmail={setEmail}
                            setPassword={setPassword}
                            login={login}
                          />
                        )}
                        <div style={{ marginTop: "20px", textAlign: "center" }}>
                          <Button
                            variant="contained"
                            color="primary"
                            onClick={() => setIsSignup(!isSignup)}
                          >
                            {isSignup
                              ? "Already have an account? Sign In"
                              : "Sign Up"}
                          </Button>
                        </div>
                      </div>
                    </React.Fragment>
                  ) : (
                    <Home sessionManager={sessionManager} />
                  )
                }
              />
            </Routes>
          </LoadScript>
        </div>
      </Router>
    </ThemeProvider>
  );
}

export default App;
